export function parseJwt(encoded: string): {
    FirstNameClaim: string;
    LastNameClaim: string;
    EmailClaim: string;
    IdentityId: string;
    auth_time: number;
    exp: number;
} {
    if (encoded == null) return null;

    const parts = encoded.split('.');
    const base64Payload = parts[1].replaceAll('-', '+').replaceAll('_', '/');
    const decoded = globalThis.atob(base64Payload);
    const stringPayload = decodeURIComponent([...decoded]
        .map(m => '%' + ('00' + m.codePointAt(0).toString(16)).slice(-2))
        .join(''));

    return JSON.parse(stringPayload);
}